import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Quantidade positiva de verdade: `Validators.min(0.0001)` ou `min(Number.EPSILON)` dependem da
 * precisão do campo e escondem a intenção. Vazio não é erro aqui — `required` cuida disso.
 */
export function maiorQueZeroValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const valor = control.value;

        if (valor === null || valor === undefined || valor === '') return null;

        return Number(valor) > 0 ? null : { maiorQueZero: true };
    };
}
